module.exports = __webpack_public_path__ + "img/react.995dfff5.png";